import React from 'react';
import Header from './Header';
import ProgramDescription from './ProgramDescription';
import Modules from './Modules';
import AdditionalContent from './AdditionalContent';

const Body = () => {
  return (
    <div className="content">
      <Header />
      <ProgramDescription />
      <Modules />
      <AdditionalContent />
    </div>
  );
};

export default Body;
